import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
// import { amendContract } from '../../../api'
import { KTSVG } from '../../../_metronic/helpers'

function AmendContractModal({
  isOpen,
  onClose,
  onSuccess,              // ← add
  enterpriseId,
  enterpriseName,
  currentContractStartDate,      // ← new prop
  currentContractDurationMonths, // ← new prop
}) {
  const [formData, setFormData] = useState({
    contract_start_date: '',
    contract_duration_months: '',
  })
  const [loading, setLoading] = useState(false)

  // Pre-fill with current contract values when modal opens
  useEffect(() => {
    if (isOpen) {
      setFormData({
        contract_start_date: currentContractStartDate || '',    // raw YYYY-MM-DD directly
        contract_duration_months: currentContractDurationMonths
          ? String(currentContractDurationMonths)
          : '',
      })
    }
  }, [isOpen, currentContractStartDate, currentContractDurationMonths])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  // const validateForm = () => {
  //   if (!formData.contract_start_date) return 'Contract Start Date is required.'
  //   if (!formData.contract_duration_months || Number(formData.contract_duration_months) < 1)
  //     return 'Contract Duration must be at least 1 month.'
  //   return null
  // }

  const handleSubmit = async () => {
    // const error = validateForm()
    // if (error) { Swal.fire({ icon: 'error', title: error }); return }
    // setLoading(true)
    // try {
    //   await amendContract({
    //     enterprise_id: enterpriseId,
    //     contract_start_date: formData.contract_start_date,
    //     contract_duration_months: Number(formData.contract_duration_months),
    //   })
    //   Swal.fire({ icon: 'success', title: `Contract amended for ${enterpriseName}` }).then(() => {
    //     handleClose()
    //     onSuccess?.()         // ← add
    //   })
    // } catch (error: any) {
    //   Swal.fire({ icon: 'error', title: error.response?.data?.detail || 'Failed to change contract.' })
    // } finally {
    //   setLoading(false)
    // }
  }

  const handleClose = () => {
    setFormData({ contract_start_date: '', contract_duration_months: '' })
    onClose()
  }

  return (
    <div className={`modal fade ${isOpen ? 'show' : ''}`} tabIndex={-1} style={{ display: isOpen ? 'block' : 'none' }}>
      <div className='modal-dialog' style={{ marginTop: '9rem' }}>
        <div className='modal-content'>
          <div className='modal-header'>
            <h3 className='modal-title'>Change Contract — {enterpriseName}</h3>
            <div className='btn btn-icon btn-sm btn-active-secondary ms-2' onClick={handleClose}>
              <KTSVG path='media/icons/duotune/arrows/arr061.svg' className='svg-icon svg-icon-2x' />
            </div>
          </div>
          <div className='modal-body'>
            <div className='mb-3'>
              <label className='form-label required'>Contract Start Date</label>
              <input
                type='date'
                name='contract_start_date'
                className='form-control form-control-solid'
                value={formData.contract_start_date}
                onChange={handleInputChange}
              />
            </div>
            <div className='mb-3'>
              <label className='form-label required'>Duration (months)</label>
              <input
                type='number'
                name='contract_duration_months'
                className='form-control form-control-solid'
                placeholder='e.g. 12'
                value={formData.contract_duration_months}
                onChange={handleInputChange}
                min={1}
              />
            </div>
          </div>
          <div className='modal-footer'>
            <button className='btn btn-secondary' onClick={handleClose}>Cancel</button>
            <button className='btn' style={{ backgroundColor: '#6D9300', color: 'white' }} onClick={handleSubmit} disabled={loading}>
              {loading ? 'Saving...' : 'Change Contract'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AmendContractModal